import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { AuthProvider } from './context/AuthContext';
import { CaseIntakeProvider } from './context/CaseIntakeContext';
import ProviderLandingPage from './components/ProviderLandingPage';
import CaseIntakeForm from './components/CaseIntakeForm';
import CaseReport from './components/CaseReport';
import Login from './components/Login';
import Register from './components/Register';
import CompleteRegistration from './components/CompleteRegistration';
import NotFound from './components/NotFound';
import AdminPortal from './components/AdminPortal';
import RegisterAdmin from './components/RegisterAdmin';
import RegistrationResult from './components/RegistrationResult';

function App() {
  useEffect(() => {
    if (window.location.hostname === 'preciscacasereviews.com' || window.location.hostname === 'www.preciscacasereviews.com' || window.location.hostname === 'preciscacasereview.com' || window.location.hostname === 'www.preciscacasereview.com') {
      window.location.href = 'https://precisca.ai';
    }
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <CaseIntakeProvider>
          <CssBaseline />
          <Routes>
            <Route path="/" element={<ProviderLandingPage />} />
            <Route path="/submit-case" element={<CaseIntakeForm />} />
            <Route path="/case-report" element={<CaseReport />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/complete-registration" element={<CompleteRegistration />} />
            <Route path="/admin" element={<AdminPortal />} />
            <Route path="/register-admin" element={<RegisterAdmin />} />
            <Route path="/registration-result" element={<RegistrationResult />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </CaseIntakeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
